import {
  DistanceFilterDropdown,
} from '@/scopes/search/search/pages/SearchPage/components/Filters/DistanceFilters/DistanceFilterDropdown'

export function MetersToSlopeFilter() {
  return (
    <DistanceFilterDropdown
      filterType="MetersToSlope"
      labelId="search_filter_meters_to_slope_label"
      analyticsType="distance from slope"
      dataQa="meters-to-slope-filter"
    />
  )
}
